import { requestApi, BaseResponse } from '~/services/api-new';

export type WelcomePageDetailsResponse = {
	lastLoginTime: string;
	accumulatedLoss: string;
	depositLimits: { timeConst: number; limit: number }[];
	totalBalance: string;
	PARAM_MAX_OPERATION: string;
	accumulatedWager: string;
	timeLimits?: { list: [] };
	balance?: {
		limitAmount: number;
	};
};

export const getWelcomePageDetails = async () => {
	const response = await requestApi<BaseResponse<WelcomePageDetailsResponse>>({
		endpoint: `/welcomePageDetails?x=${new Date().getTime()}`
	});

	return response;
};

export const getCurrentSessionInfo = async () => {
	return requestApi({ endpoint: `/player/currentSessionInfo` });
};

export default { getWelcomePageDetails, getCurrentSessionInfo };
